<template>
    <div class="OfficeAdd" v-if="lang">
        <div class="header header-mobile">
            <aside class="step">
                <div class="circle active">&nbsp;</div>
                <span class="active">{{translate.pages.bids.add.tabs.address.title}}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.two.active || steps.three.active || steps.four.active }"></div>
                <span :class="{ active: steps.two.active || steps.three.active || steps.four.active }">{{translate.pages.bids.add.tabs.start_date.title}}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.three.active || steps.four.active }"></div>
                <span :class="{ active: steps.three.active || steps.four.active }">{{translate.pages.bids.add.tabs.end_date.title}}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.four.active }"></div>
                <span :class="{ active: steps.four.active }">{{translate.pages.bids.add.tabs.reason.title}}</span>
            </aside>
        </div>
        <br>
        <div class="content">
            <div v-if="steps.one.active">
                <header class="content-header">
                    <h3>{{translate.pages.bids.add.tabs.address.subtitle}}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex="100" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.office.invalid }">
                                <label>{{translate.pages.bids.add.fields.office}}</label>
                                <md-select name="office" id="office" v-model="data.office_id" @change="changeSelect(data.office_id)">
                                    <md-option v-for="office in offices" :value="office.id" :key="office.id">{{ office.name }}</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.office.invalid">{{ errors.office.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else-if="steps.two.active">
                <header class="content-header">
                    <h3>{{translate.pages.bids.add.tabs.start_date.subtitle}}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter style="margin-bottom: 80px">
                        <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                            <label>{{translate.pages.bids.add.fields.discount_date}}</label>
                            <md-icon class="icon-calendar">today</md-icon>
                            <date-picker :option="option" :limit="limit" class="picker" :date="startDate"></date-picker>
                            <span class="span-error" v-if="errors.date.invalid">{{ errors.date.msg }}</span>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50">
                            <md-input-container class="datepicker--block" style="padding 6px 0; margin-top: 32px;" :class="{ 'md-input-invalid' : errors.hasOwnProperty('hora') }">
                                <md-icon style="margin-right: 10px;">access_time</md-icon>
                                <label>{{translate.pages.bids.add.fields.discount_time}}</label>
                                <md-select v-model="data.time" :disabled="disabledHours">
                                    <md-option v-for="(hour,index) in hours" :key="index" :value="hour">{{ hour }}</md-option>
                                </md-select>
                                <span class="span-error large-error" v-if="!hours.length">No cuenta con Horas disponibles para la fecha seleccionada, verifique el horario de la consulta seleccionada</span>
                                <span class="span-error" v-if="errors.time.invalid && hours.length">{{ errors.time.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else-if="steps.three.active">
                <header class="content-header">
                    <h3>{{translate.pages.bids.add.tabs.end_date.subtitle}}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex-small="100" md-flex="50" class="container"
                            v-for="prevision in previsions" :key="prevision.id">
                            <md-input-container :class="{ 'md-input-invalid' : prevision.errors.invalid }">
                                <label>{{ prevision.display_name }}</label>
                                <md-input type="number" min="0" max="100" v-model="prevision.percentage"></md-input>
                                <span class="md-error" v-if="prevision.errors.invalid">{{ prevision.errors.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else>
                <header class="content-header">
                    <h3>{{translate.pages.bids.add.tabs.reason.subtitle}}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex="100" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.speciality.invalid }">
                                <label>{{translate.pages.bids.add.fields.speciality}}</label>
                                <md-select name="speciality" id="speciality" v-model="data.speciality_id">
                                    <md-option v-for="speciality in specialities" :value="speciality.id" :key="speciality.id">{{ speciality.name }}</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.speciality.invalid">{{ errors.speciality.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <footer class="content-footer">
                <hr>
                <div class="buttons clearfix">
                    <div class="return">
                        <md-button class="md-raised md-size" :disabled="steps.button" @click.native="previous"><md-icon>keyboard_arrow_left</md-icon> {{translate.pages.bids.add.buttons.back}}</md-button>
                    </div>
                    <div class="next">
                        <md-button class="md-raised md-primary md-size btn--blue" @click.native="next" :disabled="process">{{translate.pages.bids.add.buttons.follow}} <md-icon>keyboard_arrow_right</md-icon></md-button>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
    import { doctor } from '../../../config/api.js';
    const swal = require('sweetalert2');
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    export default {
        data() {
            return {
                startDate: { time: moment().add(3, "days").format('DD/MM/YYYY') },
                endDate: { time: moment().add(3, "days").format('DD/MM/YYYY') },
                option: options,
                limit: [
                    {
                        type: 'fromto',
                        from: moment().add(2, "days"),
                        to: ''
                    }
                ],
                steps: {
                    'one': {
                        active: true,
                        valid: false
                    },
                    'two': {
                        active: false,
                        valid: false
                    },
                    'three': {
                        active: false,
                        valid: false
                    },
                    'four': {
                        active: false,
                        valid: false
                    },
                    'current': 'one',
                    'button': true
                },
                data: {
                    'office_id': '',
                    'date': '',
                    'time': '',
                    'time_value': {
                        HH: '',
                        mm: ''
                    },
                    /*'fonasa': '10',
                    'isapre': '10',
                    'particular': '10',*/
                    'previsions' : [],
                    'speciality_id': ''
                },
                offices: [],
                specialities: [],
                previsions: [],
                hours: [],
                process: false,
                disabled: true,
                disabledHours: true,
                errors: {
                    'office': {
                        'invalid': false,
                        'msg': ''
                    },
                    'date': {
                        'invalid': false,
                        'msg': ''
                    },
                    'time': {
                        'invalid': false,
                        'msg': ''
                    },
                    'fonasa': {
                        'invalid': false,
                        'msg': ''
                    },
                    'isapre': {
                        'invalid': false,
                        'msg': ''
                    },
                    'particular': {
                        'invalid': false,
                        'msg': ''
                    },
                    'speciality': {
                        'invalid': false,
                        'msg': ''
                    },
                    'response': {
                        'invalid': false,
                        'msg': ''
                    }
                },
            }
        },
        created() {
            let url = doctor.api.offices;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get offices
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get previsions
            this.$http.get('/previsions?country=' + this.$route.params.country)
                .then(response => {
                    let data = response.data.data;
                    data.map(item => { item.percentage = 10; item.errors = { invalid: false, msg: '' } });
                    this.previsions = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            this.data.date = this.startDate.time;
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Validate step form
            next() {
                let error = false;
                if(this.steps.current == 'one')
                {
                    // validate one
                    if(this.data.office_id.length == 0)
                    {
                        this.errors.office.invalid = true;
                        this.errors.office.msg = this.translate.pages.bids.add.validations.office;
                        error = true;
                    }else{
                        this.errors.office.invalid = false;
                        this.errors.office.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.one.active = false;
                        this.steps.one.valid = true;
                        this.steps.two.active = true;
                        this.steps.button = false;
                        this.steps.current = "two";
                    }
                    this.getHours();
                }else if(this.steps.current == 'two'){
                    // validate two
                    if(this.data.date.length == 0)
                    {
                        this.errors.date.invalid = true;
                        this.errors.date.msg = this.translate.pages.bids.add.validations.date;
                        error = true;
                    }else{
                        this.errors.date.invalid = false;
                        this.errors.date.msg = "";
                    }
                    if(this.data.time.length == 0)
                    {
                        this.errors.time.invalid = true;
                        this.errors.time.msg = this.translate.pages.bids.add.validations.time;
                        error = true;
                    }else{
                        this.errors.time.invalid = false;
                        this.errors.time.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.two.active = false;
                        this.steps.two.valid = true;
                        this.steps.three.active = true;
                        this.steps.button = false;
                        this.steps.current = "three";
                    }
                }else if(this.steps.current == 'three'){
                    this.previsions.forEach(item => {
                        if(item.percentage == "" ||  parseInt(item.percentage) < 0 || parseInt(item.percentage) > 100){
                            item.errors.invalid = true;
                            // TODO: Update language
                            item.errors.msg = "Ingrese porcentaje de descuento (0 - 100%) para " + item.display_name;
                            error = true;
                        }else{
                            item.percentage = parseInt(item.percentage);
                            item.errors.invalid = false;
                            // TODO: Update language
                            item.errors.msg = "";
                        }
                    });
                    if(error){
                        return false;
                    }else{
                        this.steps.three.active = false;
                        this.steps.three.valid = true;
                        this.steps.four.active = true;
                        this.steps.button = false;
                        this.steps.current = "four";
                    }
                }else{
                    if(this.data.speciality_id.length == 0)
                    {
                        this.errors.speciality.invalid = true;
                        this.errors.speciality.msg = this.translate.pages.bids.add.validations.speciality;
                        error = true;
                    }else{
                        this.errors.speciality.invalid = false;
                        this.errors.speciality.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.process = true;
                        let url = doctor.api.bids;
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.previsions.map(item => { this.data.previsions.push({id: item.id, percentage: item.percentage}); });
                        this.$http.post(url, this.data, {
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                this.process = false;
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.$router.push({'name': 'Bid'});
                                    }, (dismiss) => {
                                        console.log(dismiss);
                                        this.$router.push({'name': 'Bid'});
                                    });
                            }).catch(error => {
                                this.process = false;
                                if(error.response.status === 422){
                                    let data = error.response.data;
                                    console.log(data);
                                    for(let index in data)
                                    {
                                        this.errors[index].invalid = true;
                                        let messages = '';
                                        data[index].forEach( item => messages += item + ' ');
                                        this.errors[index].msg = messages;
                                    }
                                    this.errors.response.invalid = false;
                                }else if(error.response.status === 404){
                                    this.errors.response.invalid = true;
                                    this.errors.response.msg = error.response.data.message;
                                }
                            });
                    }
                }
            },
            // Validate step form
            previous() {
                if(this.steps.current == 'two'){
                    this.steps.two.active = false;
                    this.steps.one.active = true;
                    this.steps.button = true;
                    this.steps.current = 'one';
                }else if(this.steps.current == 'three'){
                    this.steps.three.active = false;
                    this.steps.two.active = true;
                    this.steps.button = false;
                    this.steps.current = 'two';
                }else if(this.steps.current == 'four'){
                    this.steps.four.active = false;
                    this.steps.three.active = true;
                    this.steps.button = false;
                    this.steps.current = 'three';
                }
            },
            // Change select office
            changeSelect(office_id){
                this.offices.forEach(office => {
                    if(office.id == office_id){
                        this.specialities = office.specialities;
                        return false;
                    }
                });
            },
            // Update time
            updateTime($event, target){
                this.data[target] = $event.data.HH + ':' + $event.data.mm;
            },
            // Get hours
            getHours: function(){
                this.data.time = '';
                this.disabledHours = true;
                let filter = {'date': this.data.date, 'office_id':this.data.office_id};
                // consult
                this.$http.post('/diary/getHours', filter ,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    }).then(response => {
                        this.hours = response.data;
                        this.disabledHours = false;
                    });
            }
        },
        watch: {
            'startDate.time': function(value){
                this.data.date = value;
                this.getHours();
            }
        },
        components: {
            'date-picker': myDatepicker,
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .OfficeAdd
        padding 3em 2.5em
        .large-error
            bottom -50px !important
        .amoltimer .md-icon, .amolpicker.container-date .md-icon
            color #959ea6
            position absolute
            left 15px
            top 48px
            z-index 2
        .header
            border 1px solid color_form_border
            border-radius 5px
            display flex
            font-size .9em
            font-weight bold
            justify-content space-around
            padding 1em 2em
            .step
                display flex
                cursor pointer
                .circle
                    border 1px solid color_form_border
                    border-radius 50%
                    height 18px
                    margin-right .5em
                    width 18px
                    &.active
                        background color_confirm
                        border-color color_confirm
                .active
                    color color_confirm
            .navigation
                height 2px
                background color_form_border
                min-width 10% !important
                margin-top .75em
        .content
            border 1px solid color_form_border
            border-radius 5px
            padding 1em 2em
            .h10
                height 10%
            .error
                color color_error
            &-header
                h3
                    margin-bottom 1em
            &-main
                .container
                    padding 0.25em 1em
                    .multiple
                        border 1px solid color_form_border
                        border-radius 5px
                        width 100%
                        .title
                            margin 0.5em
                            color color_form_placeholder
                        .select
                            overflow-y scroll
                            overflow-x hidden
                            margin 0.25em
                            height 110px
                            .option
                                width 95%
                                margin 0.25em
                    .subtitle
                        margin-top .5em
                        color color_form_placeholder
                    .w100
                        width 100%
                    .w90
                        width 90%
                    .w10
                        width 10%
                        margin-top 0
                    .span-error
                        color #ff5722
            &-footer
                margin-top 2em
                hr
                    background color_form_border
                    margin-bottom 1em
                    opacity 0.5
                min-height 5em
                .return
                    float left
                .next
                    float right
                    button
                        background color_main !important
                        color white
    .color_form_placeholder
        color color_form_placeholder
</style>



// WEBPACK FOOTER //
// Add.vue?494f6996